'use client';

import Image from 'next/image';
import Link from 'next/link';

import Skeleton from '@/app/(football)/[team]/_components/common/Skeleton';

export interface TopItemListItemProps {
  teamSlug: string;
  methodIdx: number;
  title: string;
  point: number;
  image: string;
  rank: number;
}

export function TopItemListItem({ teamSlug, methodIdx, title, point, image, rank }: TopItemListItemProps) {
  return (
    <Link href={`/${teamSlug}/point-lounge/use/${methodIdx}`} className="flex w-[120px] flex-col gap-3">
      {/* Image Container */}
      <div className="relative flex h-[120px] w-[120px] items-center justify-center overflow-hidden rounded bg-popular-product-list-image-bg">
        {/* Rank Badge */}
        <span className="typo-body-4 absolute top-0 left-0 z-10 flex h-6 w-6 items-center justify-center rounded-tl rounded-br bg-popular-product-list-rank-bg text-popular-product-list-rank-text">
          {rank}
        </span>
        <Image src={image} alt={title} width={120} height={120} className="object-cover" />
      </div>

      {/* Text Container */}
      <div className="flex w-full flex-col gap-1">
        <span className="typo-body-6 line-clamp-1 w-full overflow-hidden text-ellipsis text-popular-product-list-text">
          {title}
        </span>
        <span className="typo-heading-5 line-clamp-1 overflow-hidden text-ellipsis text-popular-product-list-text">
          {point.toLocaleString()}P
        </span>
      </div>
    </Link>
  );
}

export function TopItemListItemSkeleton() {
  return (
    <div className="flex w-[120px] flex-col gap-3">
      <Skeleton width={120} height={120} borderRadius={4} />
      <div className="flex w-full flex-col gap-1">
        <Skeleton width={120} height={18} borderRadius={4} />
        <Skeleton width={80} height={20} borderRadius={4} />
      </div>
    </div>
  );
}
